module.exports = __webpack_public_path__ + "img/user-2.2b939b5e.png";